import { type BannerTheme } from './banner.component';
import { type ColorOrType } from './banner.directive';

export interface BannerElement {
  status: string;
  details?: string[];
  links?: {
    label: string;
    externalLink?: string | null;
    routerLink?: string | null;
    queryParams?: Record<string, any> | null;
    ariaLabel?: string | null;
    onClick?: (event: Event) => void;
  }[];
}

export function mapDeprecatedColorToType(color: ColorOrType): BannerTheme {
  switch (color) {
    case 'info':
    case 'blue': {
      return 'info';
    }
    case 'warn':
    case 'yellow': {
      return 'warn';
    }
    case 'error':
    case 'red': {
      return 'error';
    }
    default: {
      return 'info';
    }
  }
}
